import "./QuizPage.scss";
import Quiz from "../components/Quiz/Quiz";

const QuizPage = () => {
  return (
    <div className="quiz-page">
      <Quiz />
    </div>
  );
};

export default QuizPage;
